import { DataGrid, rows } from "colbi_web_ui/lib/components";
import HeaderTitleWrapper from "../components/HeaderTitle/HeaderTitleWrapper";
import ShowAllFindingsButton from "../components/FindingButtons/ShowAllFindingsButton";
import App from "../controllers/App/App";
import RulesToolbar from "../components/RulesToolbar/RulesToolbar";
import { REACT_APP_DEFAULT_PAGE_SIZE } from "../environmentVariables";

const queries = (args = {}) => [
    {
        resource: "nc_rule_result",
        args: {
            projectId: args.projectId,
            fiscalYear: args.fiscalYear,
            modulePrefix: args.modulePrefix,
            id: args.id,
            importId: args.importId,
            locale: args.locale || "en",
        },
        body: `DescriptionDetail,RuleType,RuleDetailedFinding,RuleID`,
        isDatagridReq: true,
    },
    {
        resource: args.id === "0" ? "nc_schema_findings_lines" : `nc_findings_lines`,
        args: {
            projectId: args.projectId,
            fiscalYear: args.fiscalYear,
            modulePrefix: args.modulePrefix,
            id: args.id,
            importId: args.importId,
            locale: args.locale || "en",
            page: parseInt(args.page, 10) || 0,
            pageSize: parseInt(args.pageSize || REACT_APP_DEFAULT_PAGE_SIZE),
        },
        body: `
        items {
                    __typename,
                    F1,
                    F2,
                    F3,
                    F4,
                    F5,
                    F6,
                    F7,
                    F8,
                    EntityID,
                    EntityName,
                    TypeByField,
                    ImportID,
                    DataFile,
                    id,
                    AuditStatusTotal,
                    AuditStatus,
                    detailPanel,
                    ImportIDFindings
            }, hasMore, total, headerItems`,
        isDatagridReq: true,
    },
    {
        resource: `nc_findings_lines_export`,
        args: {
            projectId: args.projectId,
            fiscalYear: args.fiscalYear,
            modulePrefix: args.modulePrefix,
            id: args.id,
            importId: args.importId,
            locale: args.locale || "en",
            page: parseInt(args.page, 10) || 0,
            pageSize: parseInt(args.pageSize, 10) || 24,
        },
        body: `
        items {
            F1,
            F2,
            F3,
            F4,
            F5,
            F6,
            F7,
            F8,
            ImportID,
            EntityName,
        }, hasMore, total, headerItems`,
        downloadable: true,
        downloadOnly: true,
    },
];

const findingRuleByFile = (path, navigation, exact, title, navByImportId = false) => ({
    path,
    navigation,
    component: App,
    exact: true,
    navByImportId,
    queries,
    title: ["label(Audit)", title],
    buttonConfig: {
        showButton: true,
        label: "Download",
        type: "single",
    },
    components: [
        {
            component: HeaderTitleWrapper,
            props: {
                title: ["query(0).RuleID", "query(0).DescriptionDetail"],
            },
        },
        {
            component: DataGrid,
            props: {
                id: "results",
                items: "query(1).list",
                filter: "param(filter)",
                availableFilters: [],
                card: rows.CellCard,
                metadata: "query(1).metadata",
                page: "param(page)",
                status: "status(1)",
                pageSize: "param(pageSize)",
                sort: "param(sort)",
                pageDefault: 10,
                header: "query(1).header",
                showDetailPanel: "query(1).showDetailPanel",
                showCheckbox: "query(1).showCheckbox",
                toolbar: RulesToolbar,
                toolbarProps: {
                    hideDetailButton: "query(0).RuleDetailedFinding",
                    ruleId: "param(id)",
                    projectId: "param(projectId)",
                    fiscalYear: "param(fiscalYear)",
                    importId: "param(importId)",
                    modulePrefix: "param(modulePrefix)",
                    ruleDescription: "query(0).DescriptionDetail",
                    origin: "R",
                    title: ["query(0).RuleType", " - ", "query(0).DescriptionDetail"],
                },
            },
        },
        {
            component: ShowAllFindingsButton,
            props: {
                hideDetailButton: "query(0).RuleDetailedFinding",
                ruleId: "param(id)",
                projectId: "param(projectId)",
                fiscalYear: "param(fiscalYear)",
                importId: "param(importId)",
                modulePrefix: "param(modulePrefix)",
                ruleDescription: "query(0).DescriptionDetail",
                origin: "R",
                findingsAmount: "query(1).metadata.total",
                alignStart: true,
            },
        },
    ],
});

export default findingRuleByFile;
